import React from 'react';
import {
  DialogContent,
  DialogTitle,
  Dialog,
  makeStyles,
  Typography,
  IconButton,
} from '@material-ui/core';
import FileViewer from '../../../components/file-viewer/components/file-viewer';
import {
    APIUrlDefault,
} from '../../../utils/configuration';
import { checkEmptyObject } from '../../../utils/configuration';
//--- Material Icon
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const ViewStatePriceFile = (props) => {
  const { filePreview } = props;
  const classes = useStyles();

  const { isOpen, onClose } = props;
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth='md'>
      <DialogTitle disableTypography className='border-bottom'>
        <Typography variant='h6'>Xem file</Typography>
        <IconButton
          aria-label='close'
          className={classes.closeButton}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers={'paper'}>
              {filePreview && (
                  <FileViewer
                      key={'filePreview'}
                      fileId={'filePreview'}
                      fileType={'pdf'}
                      filePath={
                           APIUrlDefault + filePreview
            }
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewStatePriceFile;
